import {ICartShopListEntry} from "@/models/cart/CartShopModels";
import {ICartPositionShopSimple} from "@/models/cart-position/CartPositionShopModels";
import {UnitOfMeasure} from "@/helpers/constants";

export default class CartPositionBulkOfferEligibilityHelper {

	public static applyBulkOfferFlags(carts: ICartShopListEntry[], thresholdMeters: number | null): void {
		carts.forEach(cart => cart.positions.forEach(position => this.applyBulkOfferFlag(position, thresholdMeters)));
	}

	private static applyBulkOfferFlag(position: ICartPositionShopSimple, thresholdMeters: number | null): void {
		position.bulkOfferThresholdMeters = thresholdMeters;
		position.canRequestBulkOffer = this.canRequestBulkOffer(position, thresholdMeters);
	}

	private static canRequestBulkOffer(position: ICartPositionShopSimple, thresholdMeters: number | null): boolean {
		return thresholdMeters !== null
			&& position.frameAssembly === null
			&& position.item.salesUnitOfMeasure === UnitOfMeasure.unitMeter
			&& position.quantity >= thresholdMeters;
	}

}
